import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            display: true,
            grid: {
                offset: true
            },
            stacked: true,
            ticks: {
                color: "white",
                font: {
                    size: 10,
                    // letterSpacing is not supported by Chart.js - removed
                },
                autoSkip: true, // Allow Chart.js to automatically skip labels if needed
                maxRotation: 45, // Reduced rotation for better readability
                minRotation: 0,
                maxTicksLimit: 8, // Reduced to prevent overcrowding
                callback: function(value, index) {
                    // Truncate labels to 12 characters with ".." at the end
                    const label = this.getLabelForValue(value);
                    if (label.length > 12) {
                        return label.substring(0, 12) + '..';
                    }
                    return label;
                }
            }
        },
        y: {
            display: false
        }
    },
    // Remove fixed barThickness to allow dynamic sizing
    // barThickness: 15,
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    plugins: {
        legend: {
            display: false
        },
        title: {
            display: false,
            text: 'Consumer Pe',
        },
    },
    layout: {
        padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 50 // Increased bottom padding to prevent label cropping
        }
    }
};

export default function BarChartJs({ perceptions }) {
    const labels = Object.keys(perceptions);
    const perceptionValues = Object.values(perceptions);

    const data = {
        labels,
        datasets: [
            {
                label: '',
                showLabel: true,
                data: perceptionValues,
                borderWidth: 0,
                borderRadius: 100,
                borderSkipped: false,
                backgroundColor: 'rgb(81,214,243)',
                hoverBorderColor: 'rgb(222,154,32)',
                hoverBorderWidth: 1
            },
        ],
    };

    return (
        <div style={{ width: '100%', height: '400px', position: 'relative' }}>
            <Bar options={options} data={data} />
        </div>
    );
}